import styled, { css } from 'styled-components';
import Tag from './Tag';
import { colorSchema } from 'utils/style';

const skinProp = ({ skin }) => {
  switch (skin) {
    case 'red':
      return css`
        background-color: ${colorSchema('error100')};
        color: ${colorSchema('error900')};
      `;
    case 'yellow':
      return css`
        background-color: ${colorSchema('accent100')};
        color: ${colorSchema('accent900')};
      `;
    case 'green':
      return css`
        background-color: ${colorSchema('success100')};
        color: ${colorSchema('success900')};
      `;
    case 'blue':
      return css`
        background-color: ${colorSchema('primary100')};
        color: ${colorSchema('primary900')};
      `;
    case 'grey':
    default:
      return css`
        background-color: ${colorSchema('grey200')};
        color: ${colorSchema('grey800')};
      `;
  }
};

export default styled(Tag)`
  .tag {
    ${skinProp}
    border-radius: 2px;
    font-size: 1.4rem;
    font-weight: 500;
    padding: 0.4rem;
  }
`;
